export default import.meta.ROLLDOWN_FILE_URL_4ziqp1SIezY8m5A$hydsAQ